/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';

import { colorClassNames } from '../../styles/Colors';

interface Props {
  color: string;
  size: string;
}

const IconGroups = ({ size, color }: Props) => (
  <svg version="1.1" width={size} height={size} viewBox="0 0 36 36">
    <path className={colorClassNames.stroke(color)} strokeWidth="1.5" strokeMiterlimit="10" fill="none" d="M 20.83,12.33 L 20.8,12.32 C 23.64,13.47 25.5,16.22 25.5,19.28 L 25.5,19.3 C 25.5,19.61 25.48,19.92 25.45,20.23" />
    <path className={colorClassNames.stroke(color)}  strokeWidth="1.5" strokeMiterlimit="10" fill="none" d="M 10.56,20.27 L 10.56,20.27 C 10.52,19.94 10.5,19.62 10.5,19.29 L 10.5,19.28 C 10.5,16.32 12.24,13.64 14.95,12.43" />
    <path className={colorClassNames.stroke(color)}  strokeWidth="1.5" strokeMiterlimit="10" fill="none" d="M 22.48,25.3 L 22.53,25.27 C 19.81,27.31 16.05,27.28 13.37,25.19" />
    <circle className={colorClassNames.stroke(color)}  strokeWidth="1.5" strokeMiterlimit="10" fill="none" cx="18" cy="11.88" r="3" />
    <circle className={colorClassNames.stroke(color)}  strokeWidth="1.5" strokeMiterlimit="10" fill="none" cx="24.4" cy="22.86" r="3" />
    <circle className={colorClassNames.stroke(color)}  strokeWidth="1.5" strokeMiterlimit="10" fill="none" cx="11.59" cy="22.86" r="3" />
  </svg>
);

export default IconGroups;
